var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasStock(_vm.article))?_c('div',{staticClass:"agotado"},[_vm._v(" Agotado ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }